import { HeadingFour } from "hui";
import { default as React, useContext } from "react";
import styled, { css } from "styled-components";
import HeaderContext from "../../HeaderContext";
import { GA_CATEGORY } from "../constants";
import { DropdownLink, DropdownRow, linkStyle } from "./styles";

const Frame = styled.div`
  max-width: 90vw;
  width: 970px;
`;

const cellStyle = css`
  display: inline-block;
  width: 25%;
`;

const Cell = styled.div<{ hasAlignFix: boolean }>`
  ${cellStyle}
  ${props =>
    props.hasAlignFix &&
    css`
      float: left;
    `}
`;

const OneQuarterLink = styled.a`
  ${linkStyle}
  ${cellStyle}
`;

const ThreeCells = styled.div`
  display: inline-block;
  width: 75%;
`;

const SmallCellsLink = styled.a`
  ${linkStyle}
  display: inline-block;
  width: calc(100% / 3);
`;

type CategoryLinkRow = { key: string; value: string };
type Props = {
  categories: CategoryLinkRow[];
  popularCategories: CategoryLinkRow[];
};

const CategoryDropdown: React.FC<Props> = ({
  categories,
  popularCategories
}) => {
  const { siteSource } = useContext(HeaderContext);
  return (
    <Frame>
      <DropdownRow>
        <Cell hasAlignFix={true}>
          <HeadingFour color="primary" tag={"p"}>
            Popular Categories
          </HeadingFour>
        </Cell>
        <ThreeCells>
          {popularCategories.map(({ value, key }) => (
            <SmallCellsLink
              key={key}
              href={key}
              data-ga-category={GA_CATEGORY}
              data-ga-action={`${GA_CATEGORY} - Clicked Category ${value}`}
              data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            >
              {value}
            </SmallCellsLink>
          ))}
        </ThreeCells>
      </DropdownRow>

      <DropdownRow hasBreak={true}>
        {categories.map(({ value, key }) => (
          <OneQuarterLink
            key={key}
            href={key}
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Category ${value}`}
            data-ga-label={`${GA_CATEGORY}- ${siteSource}`}
          >
            {value}
          </OneQuarterLink>
        ))}
      </DropdownRow>

      <DropdownRow hasBreak={true}>
        <DropdownLink
          isFooter={true}
          href="/find"
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Browse All Categories - Sub Menu`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
        >
          View all categories
        </DropdownLink>
      </DropdownRow>
    </Frame>
  );
};

export default CategoryDropdown;
